/**
 * @file 购票限制弹框组件
 */
<template>
  <el-dialog 
    title="请选择购票限制" 
    :visible.sync="dialogVisible" 
    width="700px"
    :close-on-click-modal="false"
    @close="handleClose">
    <el-radio-group v-model="formData.ticketRestrictions">
      <div class="flex">
        <el-radio :label="1">非实名购票</el-radio>
      </div>
      <div class="tips" style="margin:10px 0 30px;font-size:14px">乘客只提供电话号码即可购票</div>
      <div class="flex">
        <el-radio :label="2">实名购票</el-radio>
        <el-checkbox 
          label="启用小程序下单实名校验" 
          v-model="formData.customerRealName"
          :disabled="formData.ticketRestrictions != 2">
        </el-checkbox>
        <el-checkbox 
          label="启用平台下单实名校验" 
          v-model="formData.systemRealName"
          :disabled="formData.ticketRestrictions != 2">
        </el-checkbox>
      </div>
      <div class="tips" style="margin-top:10px;line-height: 20px;font-size:14px">
        * 须提供乘客真实姓名、身份证号码、联系电话才能购票
        <br />
        * 如开启实名校验，则按1人/1次/{{ verifyIdCardPrice }}元的收费规则，请确保AI识别余额充足
        <br />
        * 如关闭实名校验，则只验证身份证号码格式是否正确，不会校验乘客姓名+身份证号码是否匹配
      </div>
    </el-radio-group>

    <div slot="footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSave">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TicketRestrictionsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      formData: {
        id: null,
        ticketRestrictions: 1,
        customerRealName: false,
        systemRealName: false
      },
      verifyIdCardPrice: 0
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initFormData()
        this.getVerifyIdCardPrice()
      }
    }
  },
  methods: {
    async getVerifyIdCardPrice() {
      let url = "api/v1/manage/ai/platform/config"
      const { code, data } = await this.$axios.get(url);
      if (code == 1) {
        this.verifyIdCardPrice = data.verifyIdCard || 0
      }
    },
    /* 保存线路购票限制 */
    async handleSave() {
      let url = "/api/v1/manage/line/ticketRestrictions";
      let params = {
        id: this.formData.id,
        ticketRestrictions: this.formData.ticketRestrictions,
        customerRealName: this.formData.customerRealName ? 1 : 2,
        systemRealName: this.formData.systemRealName ? 1 : 2,
      }
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success('已修改购票限制')
        this.$emit('success', params)
      }
    },
    initFormData() {
      this.formData = {
        id: this.rowData.id,
        ticketRestrictions: this.rowData.ticketRestrictions,
        customerRealName: this.rowData.customerRealName == 1,
        systemRealName: this.rowData.systemRealName == 1
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    handleCancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
.flex {
  .el-radio {
    display: flex;
    align-items: center;
  }

  .el-radio__label {
    display: inline;
    font-weight: bold;
  }
}
</style> 